import React from "react";
import { BackgroundColor } from "types/componentBackground";
import { PartialSanityImageType } from "@silversea-ssc/ui-components-react";
import LinkCard from "../Card/LinkCard";
import * as styles from "./ExpeditionTeamMemberCard.module.scss";

interface ExpeditionTeamMemberCardProps {
  cardBackgroundColor: BackgroundColor;
  picture?: PartialSanityImageType;
  title?: string;
  name?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const ExpeditionTeamMemberCard: React.FC<
  React.PropsWithChildren<ExpeditionTeamMemberCardProps>
> = ({ picture, title, name, cardBackgroundColor, onClick }) => {
  const fullName = (
    <React.Fragment>
      {name}
      <div className={styles.title}>{title}</div>
    </React.Fragment>
  );
  return (
    <LinkCard
      backgroundColor={cardBackgroundColor}
      title={fullName}
      image={picture}
      imageRatio="custom"
      style={{ "--custom-image-aspect-ratio": "100%" } as React.CSSProperties}
      imageAltText={name}
      action={{ onClick: onClick }}
    />
  );
};

export default ExpeditionTeamMemberCard;
